import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
@Injectable({
  providedIn: "root",
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private toastr: ToastrService, private router: Router) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const authorization = request.headers.get("Authorization");
    if (
      authorization &&
      /^bearer\s+(null|undefined)?$/i.test(authorization.trim())
    ) {
      request = request.clone({
        headers: request.headers.delete("Authorization"),
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        const status = error && error.error && error.error.status ? error.error.status : {};
        // const url = request.url || "";
        // const isOtpRoute = /\/sendotp|\/verifyotp/i.test(url);
        if (error.status === 500) {
          this.toastr.error(status.msg);
        } else if (error.status === 401) {
          sessionStorage.clear();
          localStorage.removeItem("accesstoken");
          localStorage.removeItem("testCode");
          this.router.navigate(["/login"]);
        }

        return throwError(error);
      })
    );
  }
}
